// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
export const data = require('../assets/nbpp.json');

export const environment = {
    production: data.production,
    ambiente: data.ambiente,
    recaptcha: data.recaptcha,
    uri: data.uri,
    uri_docsnbp: data.uri_docsnbp,
    youtube_channel_id: data.youtube_channel_id,
    youtube_playlist_id : data.youtube_playlist_id,
    youtube_token: data.youtube_token,
    youtube_google_key: data.youtube_google_key,
    url_inicio_portal_frontend: data.url_inicio_portal_frontend,
    url_cadastro_portal_frontend: data.url_cadastro_portal_frontend,
    url_logout_gov_br : data.url_logout_gov_br,
    url_login_gov_br: "#{url_login_govbr}#"
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts